import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { contentAPI, profilesAPI } from '../services/api';
import { useToast } from './Toast';
import '../styles/WorkspaceChrome.css';
import './InProgress.css';

function PublishedPage() {
  const { showToast } = useToast();
  const [drafts, setDrafts] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void loadData();
  }, [selectedProfile]);

  const loadData = async () => {
    try {
      setLoading(true);
      const params = { workflow_kind: 'human_research', status: 'published' };
      if (selectedProfile) params.profile_id = selectedProfile;
      const [draftsRes, profilesRes] = await Promise.all([
        contentAPI.getDrafts(params),
        profilesAPI.getProfiles(),
      ]);
      setDrafts(draftsRes.data);
      setProfiles(profilesRes.data);
    } catch (err) {
      showToast(
        err.response?.data?.error || err.message || 'Failed to load published articles',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="in-progress pf-explore published-page">
        <div className="pf-loading">Loading published articles…</div>
      </div>
    );
  }

  return (
    <div className="in-progress pf-explore published-page">
      <div className="pf-header">
        <div>
          <h2>Published</h2>
          <p className="pf-sub">
            Articles marked live in Racontera. WordPress draft links appear when a piece was pushed
            before publishing.
          </p>
        </div>
        <div className="pf-filters">
          <select
            value={selectedProfile}
            onChange={(e) => setSelectedProfile(e.target.value)}
            className="pf-filter-select"
            aria-label="Filter by topic profile"
          >
            <option value="">All topic profiles</option>
            {profiles.map((profile) => (
              <option key={profile.id} value={profile.id}>
                {profile.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="drafts-list research-briefs-fullwidth pf-list-card">
        <h3>Published ({drafts.length})</h3>
        {drafts.length === 0 ? (
          <div className="pf-empty">
            <p>No published articles yet.</p>
            <p className="pf-empty-hint">
              Mark articles published from the{' '}
              <Link to="/publishing-queue">Publishing queue</Link>.
            </p>
          </div>
        ) : (
          <div className="drafts-items">
            {drafts.map((draft) => (
              <div key={draft.id} className="draft-item research-brief-row">
                <div className="draft-item-content">
                  <h4>{draft.title}</h4>
                  <div className="draft-item-meta">
                    {draft.profile_name && (
                      <span className="meta-badge">{draft.profile_name}</span>
                    )}
                    {draft.wp_post_id && draft.wp_status && (
                      <span className="meta-badge status-wp">WP: {draft.wp_status}</span>
                    )}
                  </div>
                  <div className="draft-item-footer">
                    <span className="draft-date">
                      {draft.updated_at
                        ? new Date(draft.updated_at).toLocaleDateString()
                        : ''}
                    </span>
                  </div>
                  <div className="research-brief-row-actions">
                    <Link
                      to={`/research-brief/${draft.id}`}
                      className="pf-btn pf-btn-secondary"
                    >
                      Open workspace
                    </Link>
                    {draft.wp_edit_link && (
                      <a
                        href={draft.wp_edit_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pf-btn pf-btn-secondary"
                      >
                        Edit in WordPress
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PublishedPage;
